<template>
    <div class="default-page">

        <div class="buttons">
            <button class="button btn-primary"
                    @click="saveForm">
                {{ $ml.get('buttons.save') }}
            </button>

            <button class="button btn-primary" @click="goToList">
                {{ $ml.get('buttons.back') }}
            </button>

            <button v-for="(button, index) in buttons"
                    :class="['button', button.class]"
                    @click="button.function">
                {{ button.label }}
            </button>
        </div>

        <ArticlesSliderSection ref="articlesSliderSection" targetPage="forProfessionals"/>

    </div>
</template>

<script>
import ArticlesSliderSection from "../../Utils/ArticlesSliderSection";
import FormDefault from "../../Utils/Page/FormDefault";
import draggable from "vuedraggable";



export default {
    name: "Form",
    mixins: [FormDefault],
    components: {
        ArticlesSliderSection,
        draggable
    },
    data() {
        return {
            lang: this.$ml.get('pages.forProfessionals'),

            buttons: [],

            typeForm: {},

            pageRouteList: 'forProfessionals',
            pageRouteEdit: 'forProfessionals.edit',
            pageApi: 'forProfessionals',
            pagePermission: 'forProfessionals',
        }
    },
    mounted() {

    },
    watch: {

    },
    methods: {
        saveForm() {
            this.$refs.articlesSliderSection.saveForm()
        }
    }
}
</script>

<style scoped>

</style>
